<template>
    <span>
        <span v-if="showEditor">
            <v-input ref="el" type="text" :currentValue="newValue" @blur="blur" @change="search"></v-input>
            <div class="dropdown-button-list" v-if="options.length > 0">
                <div v-for="vehicle in options" :key="vehicle.id">
                    <v-button class="stack plain" @click="complete(vehicle)">
                        {{vehicle.stock_number}} 
                        <vehicle-inspection-icons :vehicle="vehicle"></vehicle-inspection-icons>
                        <br>
                        {{vehicle.color}} {{vehicle.year}} {{vehicle.make}} {{vehicle.model}} {{vehicle.trim}}
                        <hr>
                    </v-button>
                </div>
            </div>
        </span>
        <span v-else @click="toggleEdit()" style="cursor: pointer" :class="{modified: modified}">
            <span class="stocknumber">
                {{newValue}}
            </span> 
            <vehicle-inspection-icons :vehicle="vehicle"></vehicle-inspection-icons>
            <span v-if="vehicle">
                <br v-if="!oneline">{{vehicle.color}} {{vehicle.year}} {{vehicle.make}} {{vehicle.model}} {{vehicle.trim}}
            </span>
        </span>
    </span>
</template>

<script>
    import config from '../config'
    import VehicleInspectionIcons from './VehicleInspectionIcons.vue'

    export default {
      data () {
        return {
          vehicle: null,
          options: [],
          newValue: '',
          user_set: false,
          editing: false
        }
      },
      props: {
        currentValue: null,
        location: null,
        readonly: undefined,
        oneline: false
      },
      components: {
          'vehicle-inspection-icons': VehicleInspectionIcons
      },
      created () {
          this.newValue = this.currentValue;
          this.search(this.currentValue)
      },
      computed: {
          modified () {
              return this.currentValue !== this.newValue;
          },
          showEditor () {
              return (this.editing || !this.newValue);
          },
      },
      methods: {
          toggleEdit () {
              console.log("TOGGLE EDIT");
              if (this.readonly !== undefined) {
                  this.editing = false
              } 
              else {
                  this.editing = true
                  this.$nextTick(() => this.$refs.el.focus())
              }
          },
          search ($event) {
              if ($event === '') {
                  return this.clear();
              }

              config.stockbookApi(localStorage.getItem('authToken')).get('/vehicles?stock_num=' + $event)
              .then(result => {
                  let vehicles = result.data
                  this.options = vehicles;

                  if(vehicles.length == 1 && vehicles[0].stock_number == $event) {
                      this.complete(vehicles[0]);
                  }
              });
          },
          complete (vehicle) {
              this.vehicle = vehicle
              this.options = []
              this.editing = false
              
              if (this.newValue !== vehicle.stock_number) {
                  this.newValue = vehicle.stock_number
                  this.$emit('change', vehicle.stock_number)
              }
          },
          clear () {
            this.newValue = ''
            this.vehicle = null
            this.options = []
            if (this.$refs.el) this.$refs.el.newValue = ''
          },
          blur (e) {
            setTimeout(() => this.editing = false, 1000)
          }
        },
        watch: {
          currentValue (value) {
            if (!this.user_set) {
              this.newValue = this.currentValue
            }
            this.search(value)
          }
        }
    }
</script>

<style scoped lang="less">
    .stocknumber {
      font-weight: bold;
    }

    .dropdown-button-list {
      position: absolute;
      z-index: 2; /* I had trouble with elements with [data-tooltip] poking through */
    }

    .modified::after {
      content: '...'
    }
    
    .modified {
      font-style: italic;
    }
</style>